import React, { useEffect, useState } from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import routes from '../../routes/Sidebar'
import SidebarSubmenu from './SidebarSubmenu'
import Logo from "../../assets/logo.png";
import Icons, { Icon } from '../../assets/icons';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

export default function HalfDesktopSidebar() {
    const { t } = useTranslation('common');
    const location = useLocation();
    const [pendingNotification, setPendingNotification] = useState(false)

    const not = useSelector(state => state.notification?.pending || false);
    useEffect(() => {
        setPendingNotification(not)
    }, [not])
    return (
        <div className="py-3 px-5 text-gray-500 dark:text-gray-400">
            <div className="mt-8 gap-1 flex content-center justify-center">
                <NavLink
                    to={'/'}
                    className=" md:mt-5 sm:mt-2 ml-3 md:text-2xl sm:text-xl font-bold text-side_bar_logo_txt_color">
                    <img className="w-auto  h-9 " src={Logo} alt="" />
                </NavLink>
            </div>

            <ul className="mt-20 ml-3">
                {routes.map((route) =>
                    route.routes ? (
                        <SidebarSubmenu route={route} key={route.name} />
                    ) : (
                      <li className={`relative ${route.path === '/alerts' ? 'step4' : ''}`} key={route.name}>
                        <NavLink
                          to={route.path}
                          title={t(`sidebar.${route.name.toLowerCase()}`)}
                          aria-label={t(`sidebar.${route.name.toLowerCase()}`)}
                          className={({ isActive }) =>
                            `p-3 inline-flex items-center justify-center w-full text-sm font-semibold transition-colors duration-150 rounded-lg ${
                              isActive
                                ? 'bg-white'
                                : 'text-side_bar_txt hover:text-gray-400'
                            }`
                          }
                        >
                          {({ isActive }) => (
                            <div className="w-5 h-5 shrink-0">
                              <Icon
                                className="w-full h-full"
                                icon={route.icon}
                                color={isActive ? '#0071BC' : '#6B7280'}
                              />
                              {route.name === 'Alerts' && pendingNotification && (
                                <div
                                  className="absolute right-3 top-2.5 flex items-center justify-center w-3 h-3 bg-[#0071BC] rounded-full shadow-lg"
                                  role="status"
                                  aria-label={t('you_have_new_alert')}
                                  title={t('you_have_new_alert')}
                                >
                                  <span className="animate-ping absolute inset-0 rounded-full bg-[#0071BC] opacity-75"></span>
                                  <span className="relative text-white text-[7px] font-bold leading-none">!</span>
                                </div>
                              )}
                            </div>
                          )}
                        </NavLink>
                      </li>
                    )
                )}
            </ul>

        </div>
    )
}
